import { FlexColumn } from 'ui-components/components/flex/column';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import type { Address } from '../types';
import { messages } from './billing-address-summary.messages';
import { WwexEditLink } from './wwex-edit-link';
import style from './billing-address-summary.module.css';

type BillingAddressSummaryProps = {
  billingFullName: string;
  billingAddress: Address;
  hasError?: boolean;
  isDisabled?: boolean;
  onEdit: () => void;
};

export const BillingAddressSummary = ({
  billingFullName,
  billingAddress,
  hasError = false,
  isDisabled = false,
  onEdit,
}: BillingAddressSummaryProps) => (
  <FlexColumn className={style.container} gap={Gap.Space4}>
    <FlexRow className={style.headerRow} gap={Gap.Space8}>
      <Text isBold className={style.sectionTitle} textType={TextType.Label} value={messages.sectionTitle} />
      <WwexEditLink hasError={hasError} isDisabled={isDisabled} onClick={onEdit} />
    </FlexRow>
    <FlexColumn gap={Gap.Space4}>
      <Text className={style.readOnlyText} textType={TextType.Caption} value={billingFullName} />
      <Text className={style.readOnlyText} textType={TextType.Caption} value={billingAddress.line1} />
      {billingAddress.line2 && <Text className={style.readOnlyText} textType={TextType.Caption} value={billingAddress.line2} />}
      {(billingAddress.city || billingAddress.state || billingAddress.postalCode) && (
        <Text
          className={style.readOnlyText}
          textType={TextType.Caption}
          value={`${billingAddress.city}, ${billingAddress.state} ${billingAddress.postalCode}`}
        />
      )}
    </FlexColumn>
  </FlexColumn>
);
